var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dropzone-wrapper",
    {
      staticClass: "documents-dropzone w-100",
      on: {
        "drag-enter": _vm.handleDragEnter,
        "drag-leave": _vm.handleDragLeave,
        "added-files": _vm.handleAddFiles,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "document-type-list",
          class: { disabled: _vm.disableChildren },
        },
        [
          _c("document-classification-header", {
            directives: [
              {
                name: "b-toggle",
                rawName: "v-b-toggle",
                value: _vm.documentRequestId,
                expression: "documentRequestId",
              },
            ],
            attrs: {
              "show-dropzone": _vm.showDropzone && !_vm.sorting,
              classification: _vm.classification,
              "completed-documents": _vm.completedDocuments,
              "total-documents": _vm.totalDocuments,
              visible: _vm.collapseVisible,
              "application-id": _vm.applicationId,
              "client-username": _vm.clientUsername,
              files: _vm.files,
              documents: _vm.documentsForHeader,
            },
            on: {
              "clear-files": _vm.handleClearFiles,
              disabled: function ($event) {
                _vm.disableChildren = $event
              },
              "add-files": _vm.handleAddFiles,
            },
          }),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              attrs: { id: _vm.documentRequestId },
              model: {
                value: _vm.collapseVisible,
                callback: function ($$v) {
                  _vm.collapseVisible = $$v
                },
                expression: "collapseVisible",
              },
            },
            [
              _c("document-classification-body", {
                attrs: {
                  "application-id": _vm.applicationId,
                  "client-username": _vm.clientUsername,
                  classification: _vm.classification,
                  documents: _vm.documentsInClassification,
                  comments: _vm.comments,
                },
                on: {
                  "open-tags": function ($event) {
                    return _vm.$emit("open-tags", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }